import { render, staticRenderFns } from "./WidgetModalWindow.vue?vue&type=template&id=1a6c40c0&scoped=true"
import script from "./WidgetModalWindow.vue?vue&type=script&lang=js"
export * from "./WidgetModalWindow.vue?vue&type=script&lang=js"
import style0 from "./WidgetModalWindow.vue?vue&type=style&index=0&id=1a6c40c0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a6c40c0",
  null
  
)

export default component.exports